<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Izaberite vrstu poslovne jedinice"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>
